<template>
  <div v-if="project">
    <!-- <v-toolbar dense flat class="sticky-toolbar-breadcrumb"> -->
    <v-toolbar elevation="1" dark dense color="#296C9A" flat class="sticky">
      <v-toolbar-title>{{project.name}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div v-bind:class="!$vuetify.breakpoint.lgAndUp ? 'container': ''">
      <v-card tile>
        <v-expansion-panels active-class="flat elevation-0" class="flat elevation-0">
          <v-expansion-panel active-class="flat elevation-0" class="flat elevation-0">
            <v-expansion-panel-header>Project detail</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider></v-divider>
              <v-container>
                <div class="headline">{{project.buildingName}}</div>
                <div class="project_container">
                  <div class="contact_container">
                    <v-container>
                      <v-subheader class="pa-0">
                        <v-icon color="primary">account_circle</v-icon>
                        {{$t('contact')}}
                      </v-subheader>
                      <div v-html="project.contactName"></div>
                      <div v-html="project.mobile"></div>
                      <div v-html="project.email"></div>
                    </v-container>
                  </div>
                  <div class="address_container">
                    <v-container>
                      <v-subheader class="pa-0">
                        <v-icon color="primary">house</v-icon>
                        {{$t('address')}}
                      </v-subheader>
                      <div>{{project.street}} {{project.no}}</div>
                      <div>{{project.postalCode}} {{project.city}}</div>
                      <div>{{project.country}}</div>
                    </v-container>
                  </div>
                  <div class="image_container">
                    <img v-if="project.image" :src="project.image" />
                  </div>
                </div>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
      <!-- <v-card class="mt-3"> -->
      <v-toolbar class="mt-3" flat dense>
        <v-toolbar-title>{{$t('buildingComponents')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <dataTable v-on:clickItem="details" :items="buildingComponents" :progress="progress" :headers="headers">
        <template v-slot:itemAction="{item}">
          <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
            <template v-slot:activator="{ on }">
              <v-btn @click.prevent @click.stop color="primary" icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-sheet flatwidth="300px">
              <v-list dense>
                <can I="download" a="excel">
                  <v-list-item @click.stop="downloadExcel(item)">
                    <v-list-item-icon>
                      <v-icon color="success">fa-file-excel</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{$t('download')}}</v-list-item-content>
                  </v-list-item>
                </can>
                <can I="download" a="logbook">
                  <!-- <v-list-item @click.stop="downloadLogbook(item)">
                    <v-list-item-icon>
                      <v-icon color="primary">import_contacts</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{$t('download')}}</v-list-item-content>
                  </v-list-item> -->
                   <downloadLogbook v-on:download="(...args)=>downloadLogbook(item,...args)">
                      <template v-slot:activator="{ on }">
                        <v-list-item v-on="on">
                          <v-list-item-icon>
                            <v-icon  color="primary">import_contacts</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>{{$t('download')}}</v-list-item-content>
                        </v-list-item>
                      </template>
                    </downloadLogbook>
                </can>
              </v-list>
            </v-sheet>
          </v-menu>
        </template>
        <template v-slot:cardContent="{item}">
          <v-subheader class="subheading primary lighten-3 white--text font-weight-bold">
            <a href="#" class="white--text" @click="details(item)">{{item.name }}</a>
            <v-spacer></v-spacer>
            <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
              <template v-slot:activator="{ on }">
                <v-btn @click.prevent @click.stop color="primary" icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-sheet flat>
                <v-list dense>
                  <can I="download" a="excel">
                    <v-list-item @click.stop="downloadExcel(item)">
                      <v-list-item-icon>
                        <v-icon color="success">fa-file-excel</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>{{$t('download')}}</v-list-item-content>
                    </v-list-item>
                  </can>
                  <can I="download" a="logbook">
                    <!-- <v-list-item @click.stop="downloadLogbook(item)">
                      <v-list-item-icon>
                        <v-icon color="primary">import_contacts</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>{{$t('download')}}</v-list-item-content>
                    </v-list-item> -->
                     <downloadLogbook v-on:download="(...args)=>downloadLogbook(item,...args)">
                      <template v-slot:activator="{ on }">
                        <v-list-item v-on="on">
                          <v-list-item-icon>
                            <v-icon  color="primary">import_contacts</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>{{$t('download')}}</v-list-item-content>
                        </v-list-item>
                      </template>
                    </downloadLogbook>
                  </can>
                </v-list>
              </v-sheet>
            </v-menu>
          </v-subheader>
          <v-divider></v-divider>
          <div v-ripple class="pointer" @click="details(item)">
            <v-list dense>
              <v-list-item>
                <v-list-item-content>{{$t('description')}}:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">{{ item.description }}</v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>{{$t('blueprints')}}:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">{{ item.blueprintsCount }}</v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>{{$t('createdTs')}}:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">{{ item.createdTs }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </template>
        <template v-slot:empty>
          <retry v-on:retry="getData()" v-if="retry"></retry>
          <emptyList :title="$t('noBuildingComponents')" v-else></emptyList>
        </template>
      </dataTable>
      <!-- </v-card> -->
    </div>
    <loadingDialog :dialog="loading"></loadingDialog>
  </div>
</template>



<script>
import { validationMixin } from "vuelidate";
import dataTable from "@/components/Datatable";
import retry from "@/components/Retry";
import emptyList from "@/components/EmptyList";
import downloadLogbook from "@/components/DownloadLogbook";

export default {
  name: "ProjectsDetails",
  components: {
    retry,
    emptyList,
    dataTable,
    downloadLogbook
  },
  data() {
    return {
      progress: true,
      project: null,
      buildingComponents: [],
      headers: null,
      loading: false,
      search: "",
      sortDesc: false,
      sortBy: "name"
    };
  },
  methods: {
    downloadExcel(buildingcomponent) {
      this.loading = true;
      this.$http
        .downloadExcelExport(null, buildingcomponent.id, null)
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          let date = new Date();
          link.setAttribute(
            "download",
            `${buildingcomponent.name}_${date.toLocaleDateString()}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.$noty.error(this.$t("error"));
          this.loading = false;
        });
    },
    downloadLogbook(buildingcomponent,separated,withDocuments) {
      this.loading = true;
      this.$http
        .downloadLogbook(null, buildingcomponent.id,separated,withDocuments)
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          let date = new Date();
          link.setAttribute(
            "download",
            `${buildingcomponent.name}_${date.toLocaleDateString()}.zip`
          );
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.$noty.error(this.$t("error"));
          this.loading = false;
        });
    },
    details(item) {
      this.$router.push({
        name: "ArchivedBuildingComponentDetails",
        params: { id: item.id }
      });
    },
    buildHeaders() {
      if (this.$can("delete", "buildingComponents")) {
        this.headers = [
          {
            text: this.$t("name"),
            align: "left",
            value: "name"
          },
          {
            text: this.$t("description"),
            align: "left",
            value: "description"
          },
          { text: this.$t("blueprints"), value: "blueprintsCount" },
          {
            text: this.$t("createdTs"),
            align: "left",
            value: "createdTs"
          },
          { text: this.$t("actions"), sortable: false, value: "actions" }
        ];
      } else {
        this.headers = [
          {
            text: this.$t("name"),
            align: "left",
            value: "name"
          },
          {
            text: this.$t("description"),
            align: "left",
            value: "description"
          },
          { text: this.$t("blueprints"), value: "blueprintsCount" },
          {
            text: this.$t("createdTs"),
            align: "left",
            value: "createdTs"
          }
        ];
      }
    },
    makeBreadcrumb() {
      this.$store.state.breadcrumb = [
        {
          name: this.$t("archivedProjects"),
          to: { name: "ArchivedProjects" }
        },
        {
          name: this.project.name
        }
      ];
    }
  },
  created() {
    this.$store.state.previous = {
      name: "ArchivedProjects",
      id: null,
      breadcrumb: this.$t("archivedProjects")
    };
    this.$http
      .getProject(this.$route.params.id)
      .then(res => {
        this.project = res.data;
        this.makeBreadcrumb();
      })
      .catch(err => console.log(err));

    this.$http
      .getBuildingComponents(this.$route.params.id)
      .then(res => {
        this.buildingComponents = res.data;
        this.progress = false;
      })
      .catch(err => {
        console.log(err);
        this.buildingComponents = [];
      });
    this.buildHeaders();
  }
};
</script>

<style scoped>
.project_container {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr;
  grid-gap: 1rem;
  grid-template-areas: "contact address image";
}
.address_container {
  grid-area: address;
}
.contact_container {
  grid-area: contact;
}
.image_container {
  grid-area: image;
}
.image_container > img {
  width: 100%;
}
@media (max-width: 768px) {
  .project_container {
    grid-template-columns: 1fr;
    grid-template-areas:
      "image"
      "contact"
      "address";
  }
}
</style>



// WEBPACK FOOTER //
// src/views/projects/archived/ProjectsDetails.vue